import script from "./SectionService.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionService.vue?vue&type=script&setup=true&lang=js"

import "./SectionService.vue?vue&type=style&index=0&id=420e7567&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-420e7567"]])

export default __exports__